import React from 'react';
import PropTypes from 'prop-types';
import './styles.less';
import { CustomLoader } from '../../../../components/custom-loader';

export const ClaimsEventTabView = ({ eventsData, isLoading }) => {
	if (isLoading) {
		return <CustomLoader />;
	}

	return (
		<div className="claims-event-tab">
			<>
				{eventsData ? (
					// eslint-disable-next-line react/no-danger
					<div className="claims-event-tab__table" dangerouslySetInnerHTML={{ __html: eventsData }} />
				) : (
					<div className="claims-event-tab__empty-message">События не найдены</div>
				)}
			</>
		</div>
	);
};

ClaimsEventTabView.propTypes = {
	eventsData: PropTypes.string,
	isLoading: PropTypes.bool.isRequired,
};
